import React from 'react';
import { BaseHero, Text, Link } from '@blueprint/ui';
import Head from '../Head/Head';
import styled from '@emotion/styled';
import ErrorImage from './ErrorImage';

type Props = {
    statusCode: number;
};

const StyledLink = styled(Link)(`display: block;`);

export default function Error(props: Props) {
    return (
        <>
            <Head
                pageTitle="The page you're looking for can't be found | Zoopla"
                pageDescription="The page you’re looking for doesn’t exist."
                canonicalPath="/no-page/"
            />
            <BaseHero
                title="We can't seem to find the page you're looking for"
                image={ErrorImage}
                content={
                    <>
                        <Text>{`Error code: ${props.statusCode}`}</Text>
                        <Text>
                            The page you’re looking for doesn’t exist. Here are
                            some links you might find useful:
                        </Text>
                        <div data-testid="404-header">
                            <StyledLink href="/">Home</StyledLink>
                            <StyledLink href="/for-sale/">For Sale</StyledLink>
                            <StyledLink href="/to-rent/">To Rent</StyledLink>
                            <StyledLink href="/house-prices/">
                                House prices
                            </StyledLink>
                        </div>
                    </>
                }
            />
        </>
    );
}
